import * as React from "react";

import type {
  MetricDefinitionRecord,
  UpdateMetricDefinitionRequest,
} from "@/shared/domain/metrics";

/**
 * A cell being edited: which definition, and which of its fields. Each time a
 * cell opens it's a new object, so a save that finishes later can tell its
 * own edit from one opened since, even on the same cell.
 */
export interface DefinitionEdit {
  name: string;
  field: "description" | "unit";
}

/** What the cells share with the table: the edit under way, and saving it. */
export interface DefinitionsTableActions {
  editing: DefinitionEdit | null;
  /** Opens `edit`'s editor, closing any other. */
  startEditing: (edit: DefinitionEdit) => void;
  /** Closes `edit`'s editor, unless another edit has replaced it. */
  stopEditing: (edit: DefinitionEdit) => void;
  /** Whether `edit`'s editor is still the one open. */
  isEditing: (edit: DefinitionEdit) => boolean;
  /** Saves `patch` on `definition`; rejects with the server's error. */
  save: (
    definition: MetricDefinitionRecord,
    patch: UpdateMetricDefinitionRequest,
  ) => Promise<unknown>;
  /** How many of the org's definitions use each unit. */
  unitCounts: ReadonlyMap<string, number>;
}

export const DefinitionsTableContext =
  React.createContext<DefinitionsTableActions | null>(null);
